export const FETCH_CLAIM_HISTORY_REQUEST = "FETCH_CLAIM_HISTORY_REQUEST";
export const FETCH_CLAIM_HISTORY_SUCCESS = "FETCH_CLAIM_HISTORY_SUCCESS";
export const FETCH_CLAIM_HISTORY_FAILURE = "FETCH_CLAIM_HISTORY_FAILURE";
